import { chain, RequestDataFromApi } from "@aspen/Handlers/Data/WishLists/LoadWishLists";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";

addToChainBefore(chain, RequestDataFromApi, props => {
    props.apiParameter.additionalQueryStringParameters = { "clinicalSet" : window.location.href.includes("/SuggestedClinicalSets") ? "true" : "false" }
});